import React from 'react';
import classNames from 'classnames';
import { useMediaQuery } from '@common/hooks';

import halfStar from '@alumni_v2/images/svg/half-star.svg';
import officeBag from '@alumni_v2/images/svg/officeBag.svg';
import rupeeIcon from '@alumni_v2/images/svg/rupee.svg';
import star from '@alumni_v2/images/svg/star.svg';
import thumbIcon from '@alumni_v2/images/svg/thumb.svg';
import PlacementBannerRevamp from './placementBannerRevamp';
import styles from './TopBannerRevamp.module.scss';

const TopBannerRevamp = () => {
  const { tablet } = useMediaQuery();

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.container}>
        <div className={classNames(
          styles.contentContainer, styles.expand,
          styles.bottomFlatContainer,
        )}
        >
          <div className={styles.leftContainer}>
            {tablet ? (
              <h1 className={styles.seoHeading}>
                Scaler Academy Reviews
              </h1>
            ) : (
              <div>
                <div className={styles.upperText}>
                  Find & Connect with
                </div>
                <div className={styles.lowerText}>
                  Scaler Alumni
                </div>
              </div>
            )}
            {tablet && (
              <div className={styles.contentContainer}>
                <div className={styles.ratingContainer}>
                  <div className={styles.ratingContent}>
                    <div className={styles.ratingHeader}>
                      <img
                        src={star}
                        alt="star"
                        className={styles.ratingStar}
                      />
                      {' '}
                      4.5
                      <span className={styles.maxRating}> / 5</span>
                    </div>
                    <div className={styles.ratingSubHeader}>
                      by 4,292 ratings
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {tablet && (
            <div className={styles.seoPara}>
              At Scaler, learners transform their careers,
              mastering coding and securing dream jobs. Discover genuine
              insights through honest reviews and testimonials.
            </div>
          )}
          <div className={styles.rightContainer}>
            <div className={styles.iconBox}>
              <div className={styles.icon}>
                <img src={thumbIcon} alt="icon" />
              </div>
              <div className={styles.textBox}>
                <div className={styles.headText}>1.7 Cr</div>
                <div className={styles.subText}>Highest Package</div>
              </div>
            </div>

            <div className={styles.iconBox}>
              <div className={styles.icon}>
                <img src={rupeeIcon} alt="icon" />
              </div>
              <div className={styles.textBox}>
                <div className={styles.headText}>126%</div>
                <div className={styles.subText}>Average Hike</div>
              </div>
            </div>

            <div className={styles.iconBox}>
              <div className={styles.icon}>
                <img src={officeBag} alt="icon" />
              </div>
              <div className={styles.textBox}>
                <div className={styles.headText}>93.5%</div>
                <div className={styles.subText}>Placement Rate</div>
              </div>
            </div>
          </div>
          {!tablet && (
            <div className={styles.contentContainer}>
              <div className={styles.ratingContainer}>
                <div className={styles.ratingContent}>
                  <div className={styles.ratingHeader}>
                    4.5
                  </div>
                  <div className={styles.ratingBox}>
                    <div className={styles.ratingStars}>
                      <img
                        src={star}
                        alt="star"
                        className={styles.ratingStar}
                      />
                      <img
                        src={star}
                        alt="star"
                        className={styles.ratingStar}
                      />
                      <img
                        src={star}
                        alt="star"
                        className={styles.ratingStar}
                      />
                      <img
                        src={star}
                        alt="star"
                        className={styles.ratingStar}
                      />
                      <img
                        src={halfStar}
                        alt="empty star"
                        className={styles.ratingStar}
                      />
                    </div>
                    <div className={styles.ratingSubHeader}>
                      by 4,292 ratings
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <PlacementBannerRevamp />
      </div>
    </div>
  );
};

export default TopBannerRevamp;
